import React, { useEffect, useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Grid,
  styled
} from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import Fab from '@mui/material/Fab';
import LandingPageNav from '../../components/landingpage/LandingPageNav';
import { apiget, apigetPublic } from '../../service/api';
import Footer from '../../components/Footer/footer';
import AddBlogPost from './Add';


const BlogContainer = styled(Container)(() => ({
  paddingTop: '100px',
  paddingBottom: '50px',
}));

const BlogCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  boxShadow: theme.shadows[3],
  borderRadius: '16px',
  overflow: 'hidden',
  transition: 'transform 0.3s',
  '&:hover': {
    transform: 'scale(1.02)',
  },
}));

const BlogMedia = styled(CardMedia)(() => ({
  height: 200,
}));

const BlogLink = styled(Link)(() => ({
  textDecoration: 'none',
  color: 'inherit',
}));

function Blog() {
   const { category } = useParams(); // <- capture the category from the URL
    const [posts, setPosts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [openAddDialog, setOpenAddDialog] = useState(false);
    const userid = localStorage.getItem('user_id');
    const handleOpenAdd = () => setOpenAddDialog(true);
    const handleCloseAdd = () => setOpenAddDialog(false);
    
    const placeholderPosts = [
      {
        _id: '1',
        title: 'Understanding the Mortgage Process',
        imageUrl: '/assets/sample-blog-1.jpg',
        author: 'Jet Home Loans',
        createdAt: new Date(),
        body: 'Learn the basics of applying for a home loan, common pitfalls, and how to prepare...'
      },
      {
        _id: '2',
        title: 'First-Time Homebuyer Tips',
        imageUrl: '/assets/sample-blog-2.jpg',
        author: 'Jet Team',
        createdAt: new Date(),
        body: 'Buying your first home? Here are some essential steps and insights to get you started...'
      },
      {
        _id: '3',
        title: 'Refinancing: When and Why',
        imageUrl: '/assets/sample-blog-3.jpg',
        author: 'Loan Experts',
        createdAt: new Date(),
        body: 'Thinking about refinancing your mortgage? Let’s break down the benefits and timing...'
      }
    ];
  
    useEffect(() => {
      const fetchBlogPosts = async () => {
        // Logged-in staff see all posts (incl. unpublished drafts); the public
        // category page only sees published posts.
        const result = userid ? await apiget('blog/all') : await apigetPublic('blog');
        if (result?.status === 200 && result.data.posts.length > 0) {
          setPosts(result.data.posts);
        }
        setIsLoading(false);
      };
      fetchBlogPosts();
    }, []);
  
    const filteredPosts =
    category && posts.length > 0
      ? posts.filter((post) => post.categories.includes(category))
      : posts;

  const blogToShow = filteredPosts.length > 0 ? filteredPosts : placeholderPosts;
  
    return (
      <>
        <LandingPageNav />
        <Box
          sx={{
            backgroundImage: 'url(/assets/backgroundimageforherobanner.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            minHeight: '100vh',
            pt: 5,
          }}
        >
          <Box
            sx={{
              backgroundColor: 'rgba(255,255,255,0.8)',
              minHeight: '100vh',
              zIndex: 1,
              position: 'relative',
            }}
          >
            <BlogContainer>
              <Typography variant="h4" gutterBottom sx={{ textAlign: 'center', mb: 4 }}>
                Jet HomeLoans Blog
              </Typography>
               
                {category && (
    <Typography
      variant="h3"
      sx={{
        textAlign: 'center',
        fontWeight: 'bold',
        color: '#b79a59',
        mb: 4,
        textTransform: 'capitalize',
      }}
    >
      {category}
    </Typography>
  )}

              <Grid container spacing={4}>
                {blogToShow.map((post) => (
                  <Grid item xs={12} sm={6} md={4} key={post._id}>
                    <BlogLink to={posts.length > 0 ? `${userid ? `/dashboard/blog/${post.slug || post._id}` : `/blog/${post.slug || post._id}`}` : '#'}>

                      <BlogCard>
                        {post.imageUrl && (
                          <BlogMedia image={post.imageUrl} title={post.title} />
                        )}
                        <CardContent>
                          <Typography variant="h6" gutterBottom>
                            {post.title}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            {new Date(post.createdAt).toLocaleDateString()} by {post.author}
                          </Typography>
                          <Typography variant="body2" sx={{ mt: 1 }}>
                            {post.previewBlurb}...
                          </Typography>
                        </CardContent>
                      </BlogCard>
                    </BlogLink>
                  </Grid>
                ))}
              </Grid>
  
              {posts.length === 0 && !isLoading && (
                <Typography variant="body2" sx={{ textAlign: 'center', mt: 4 }}>
                  No blog posts found. Showing sample content.
                </Typography>
              )}
            </BlogContainer>
          </Box>
          {userid && (
  <>
    <AddBlogPost
      open={openAddDialog}
      handleClose={handleCloseAdd}
      setUserAction={(res) => {
        if (res?.status === 201) {
          setPosts((prev) => [...prev, res.data.post]);
        }
      }}
    />

    <Fab
      color="primary"
      aria-label="add"
      onClick={handleOpenAdd}
      sx={{
        position: 'fixed',
        bottom: 32,
        right: 32,
        backgroundColor: '#1976d2',
        color: '#fff',
        '&:hover': {
          backgroundColor: '#115293',
        },
      }}
    >
      <AddIcon />
    </Fab>
  </>
)}


        </Box>
        <Box sx={(theme) => ({ ...theme.mixins.toolbar })} />
          <Footer />
      </>
    );
  }
  
export default Blog;
